module.exports = __webpack_public_path__ + "static/media/S1N5-3.d4519e14.svg";